module.exports = __webpack_public_path__ + "static/media/marroco.e9fffee8.jpg";